import Service from "@/services/service";

export default class OrganizationService extends Service {
  constructor() {
    super("organizations");
  }

  list(options) {
    return this.get("", options);
  }

  read(id, options) {
    return this.get(`/${id}`, options);
  }

  listStudies(id, options) {
    return this.get(`/${id}/studies`, options);
  }

  listPlans(id, options) {
    return this.get(`/${id}/plans`, options);
  }
}
